import {
  ApolloClient,
  type ErrorPolicy,
  type FetchPolicy,
  HttpLink,
  InMemoryCache,
  type WatchQueryFetchPolicy,
} from "@apollo/client";

const defaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache" as WatchQueryFetchPolicy,
    errorPolicy: "ignore" as ErrorPolicy,
  },
  query: {
    fetchPolicy: "no-cache" as FetchPolicy,
    errorPolicy: "all" as ErrorPolicy,
  },
};

export enum SERVICE_NAMES {
  pricing = "pricing",
  users = "users",
  pc = "pc",
  checkout = "checkout",
}

const API_ENDPOINTS = {
  pricing: process.env.NEXT_PUBLIC_PRICING_GATEWAY_URL,
  users: process.env.NEXT_PUBLIC_USERS_API_URL,
  pc: `${process.env.NEXT_PUBLIC_PC_API_URL}graphql`,
  checkout: process.env.NEXT_PUBLIC_PAYMENTS_API_URL,
};

const createApolloClient = (
  endpoint: string = SERVICE_NAMES.pricing,
  jwt?: string,
) => {
  const uri = API_ENDPOINTS[endpoint] ?? API_ENDPOINTS.pricing;
  return new ApolloClient({
    link: new HttpLink({
      uri: uri,
      ...(jwt ? { headers: { authorization: jwt } } : {}),
    }),
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions,
  });
};

export default createApolloClient;
